var _defs, _rect, _g, _path, _path2, _g2, _tspan, _tspan2, _tspan3, _tspan4, _g3, _mask, _path3, _path4, _g4, _tspan5, _tspan6, _tspan7, _rect2, _tspan8, _tspan9, _tspan0, _rect3, _rect4, _tspan1, _tspan10, _mask2, _path5, _path6, _g5, _tspan11, _tspan12, _tspan13, _rect5, _tspan14, _tspan15, _rect6, _rect7, _tspan16, _tspan17, _mask3, _path7, _path8, _mask4, _path9, _g6, _tspan18, _tspan19, _tspan20, _rect8, _tspan21, _tspan22, _rect9, _rect0, _tspan23, _tspan24, _mask5, _path0, _path1, _mask6, _path10, _g7, _tspan25, _tspan26, _tspan27, _rect1, _tspan28, _tspan29, _rect10, _rect11, _tspan30, _tspan31, _mask7, _path11, _path12, _g8, _tspan32, _tspan33, _tspan34, _rect12, _tspan35, _tspan36, _rect13, _rect14, _tspan37, _tspan38, _g9, _rect15, _rect16, _rect17, _rect18, _tspan39, _g0, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 312,
    viewBox: "0 0 472 312",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 312,
    rx: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11512_2147_f1",
    x: 134.7,
    y: 1421.7,
    width: 288.6,
    height: 288.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11512_2147_f1",
    x: 205,
    y: 1549,
    width: 474,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.29293 0 0 0 0 0.353365 0 0 0 0 0.257379 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11512_2147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11512_2147_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 1551,
    width: 472,
    height: 312,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11512_2147_f1",
    x: 417,
    y: 1487,
    width: 222,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_11512_2147_f1",
    x: 483.464,
    y: 1601.85,
    width: 88.2136,
    height: 38.7512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38397
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11512_2147_f1",
    x: 459,
    y: 1529,
    width: 138,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_11512_2147_f1",
    x: 552,
    y: 1630,
    width: 21,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_f1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -1551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 782_f1",
    filter: "url(#filter0_i_11512_2147_f1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11512_2147_f1)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 1551,
    width: 472,
    height: 312,
    rx: 24,
    fill: "#17270D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_f1",
    opacity: 0.38,
    filter: "url(#filter1_f_11512_2147_f1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 1566,
    r: 53,
    fill: "#4CBC18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "table_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheet-heading_f1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241 1575.32H992C997.345 1575.32 1001.68 1579.65 1001.68 1585V1607.68H231.321V1585C231.321 1579.65 235.655 1575.32 241 1575.32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241 1575.32H992C997.345 1575.32 1001.68 1579.65 1001.68 1585V1607.68H231.321V1585C231.321 1579.65 235.655 1575.32 241 1575.32Z",
    stroke: "#E3E9E0",
    strokeWidth: 0.6425
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_f1"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1587.32,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "#DDEDD4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1587.32,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#4CBC18",
    strokeWidth: 0.6425
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-minus_f1",
    d: "M243.85 1591.5H247.705",
    stroke: "#4CBC18",
    strokeWidth: 0.6425,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 196_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Property_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1594.12
  }, "Property"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Stage_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 438.71,
    y: 1594.12
  }, "Stage")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Strategy_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 541.14,
    y: 1594.12
  }, "Strategy")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Added_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 634.725,
    y: 1594.12
  }, "Added"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-sorting_f1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_f1",
    d: "M661.617 1591.98L663.866 1594.23L666.115 1591.98M663.866 1594.23L663.866 1589.73",
    stroke: "#4CBC18",
    strokeWidth: 0.6425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-default_f1"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1608H1002V1658H231V1608Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1608H1002V1658H231V1608Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 1658V1658.64H1002.64V1658H1002ZM231 1658H230.357V1658.64H231V1658ZM1002 1608H1001.36V1658H1002H1002.64V1608H1002ZM1002 1658V1657.36H231V1658V1658.64H1002V1658ZM231 1658H231.643V1608H231H230.357V1658H231Z",
    fill: "#E3E9E0",
    mask: "url(#path-13-inside-1_11512_2147_f1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_2_f1"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_2_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1628.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1628.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#DAE4D5",
    strokeWidth: 0.6425
  }))), /*#__PURE__*/React.createElement("g", {
    id: "4321 Oak Ave, Denver, CO 80202\\xE2\\x80\\xA83 bd \\xE2\\x80\\xA2 2 ba \\xE2\\x80\\xA2 1,650 sqft \\xE2\\x80\\xA2 1974 yb_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.251,
    y: 1630.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1630.3
  }, "4321 Oak Ave, Denver, CO 80202"))), /*#__PURE__*/React.createElement("text", {
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1640.3
  }, "3 bd \u2022 2 ba \u2022 1,650 sqft \u2022 1974 yb"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_2_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_f1"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71,
    y: 1620.5,
    width: 51,
    height: 25,
    rx: 4,
    fill: "#7F8F79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Acquisitions\\xE2\\x80\\xA8New Lead_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 482.819,
    y: 1630.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1630.3
  }, "Acquisitions"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1640.3
  }, "New Lead")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_2_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_2_f1"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1626.5,
    width: 34,
    height: 13,
    rx: 3.5,
    fill: "#EEF2EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1626.5,
    width: 34,
    height: 13,
    rx: 3.5,
    stroke: "#C8D2C3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Fix & Flip_f1",
    fill: "#3E4A3C",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.14,
    y: 1635.45
  }, "Fix & Flip"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_2_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "6/28/26_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 638.4,
    y: 1635.34
  }, "6/28/26"))))), /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-default_2_f1"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-2_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1658H1002V1708H231V1658Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1658H1002V1708H231V1658Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 1708V1708.64H1002.64V1708H1002ZM231 1708H230.357V1708.64H231V1708ZM1002 1658H1001.36V1708H1002H1002.64V1658H1002ZM1002 1708V1707.36H231V1708V1708.64H1002V1708ZM231 1708H231.643V1658H231H230.357V1708H231Z",
    fill: "#E3E9E0",
    mask: "url(#path-22-inside-2_11512_2147_f1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_3_f1"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_3_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1678.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1678.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#DAE4D5",
    strokeWidth: 0.6425
  }))), /*#__PURE__*/React.createElement("g", {
    id: "8765 Redwood Cir, San Francisco, CA 94102\\xE2\\x80\\xA82 bd \\xE2\\x80\\xA2 1 ba \\xE2\\x80\\xA2 1,150 sqft \\xE2\\x80\\xA2 1982 yb_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 415.454,
    y: 1680.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1690.3
  }, "2 bd \u2022 1 ba \u2022 1,150 sqft \u2022 1982 yb"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1680.3
  }, "8765 Redwood Cir, San Francisco, CA 94102"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_3_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_3_f1"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71,
    y: 1670.5,
    width: 51,
    height: 25,
    rx: 4,
    fill: "#7F8F79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Acquisitions\\xE2\\x80\\xA8New Lead_2_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1680.3
  }, "Acquisitions\u2028"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1690.3
  }, "New Lead")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_3_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_4_f1"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1676.5,
    width: 34,
    height: 13,
    rx: 3.5,
    fill: "#EEF2EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1676.5,
    width: 34,
    height: 13,
    rx: 3.5,
    stroke: "#C8D2C3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Fix & Flip_2_f1",
    fill: "#3E4A3C",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.14,
    y: 1685.45
  }, "Fix & Flip"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_3_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "5/17/25_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 640.4,
    y: 1685.34
  }, "5/17/25"))))), /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-selected_f1"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-3_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1708H1002V1758H231V1708Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1708H1002V1758H231V1708Z",
    fill: "#F7F9F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 1758V1758.64H1002.64V1758H1002ZM231 1758H230.357V1758.64H231V1758ZM1002 1708H1001.36V1758H1002H1002.64V1708H1002ZM1002 1758V1757.36H231V1758V1758.64H1002V1758ZM231 1758H231.643V1708H231H230.357V1758H231Z",
    fill: "#E3E9E0",
    mask: "url(#path-31-inside-3_11512_2147_f1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_4_f1"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-4_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1708H431V1758H231V1708Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1758H234V1708H231H228V1758H231Z",
    fill: "#43B017",
    mask: "url(#path-33-inside-4_11512_2147_f1)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_4_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1728.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "#F3FFEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1728.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#4CBC18",
    strokeWidth: 0.6425
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_f1",
    d: "M243.901 1733L245.208 1734.44C245.215 1734.45 245.224 1734.45 245.234 1734.46C245.243 1734.46 245.253 1734.46 245.264 1734.46C245.274 1734.46 245.285 1734.46 245.294 1734.46C245.304 1734.45 245.312 1734.45 245.319 1734.44L247.649 1731.88",
    stroke: "#4CBC18",
    strokeWidth: 0.6425,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "1359 Magnolia Pkwy, Boston, MA 02108\\xE2\\x80\\xA83 bd \\xE2\\x80\\xA2 3 ba \\xE2\\x80\\xA2 1,750 sqft \\xE2\\x80\\xA2 1998 yb_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 397.587,
    y: 1730.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1740.3
  }, "3 bd \u2022 3 ba \u2022 1,750 sqft \u2022 1998 yb"))), /*#__PURE__*/React.createElement("text", {
    fill: "#4CBC18",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1730.3
  }, "1359 Magnolia Pkwy, Boston, MA 02108"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_4_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_5_f1"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71,
    y: 1720.5,
    width: 56,
    height: 25,
    rx: 4,
    fill: "#7F8F79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dispositions\\xE2\\x80\\xA8Under Contract_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1730.3
  }, "Dispositions\u2028"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1740.3
  }, "Under Contract")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_4_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 445_f1"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1726.5,
    width: 38,
    height: 13,
    rx: 3.5,
    fill: "#EEF2EB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1726.5,
    width: 38,
    height: 13,
    rx: 3.5,
    stroke: "#C8D2C3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Wholesale_f1",
    fill: "#3E4A3C",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.14,
    y: 1735.45
  }, "Wholesale"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_4_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "11/28/25_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 636.4,
    y: 1735.34
  }, "11/28/25"))))), /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-selected_2_f1"
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-5_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1758H1002V1808H231V1758Z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1758H1002V1808H231V1758Z",
    fill: "#F7F9F6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 1808V1808.64H1002.64V1808H1002ZM231 1808H230.357V1808.64H231V1808ZM1002 1758H1001.36V1808H1002H1002.64V1758H1002ZM1002 1808V1807.36H231V1808V1808.64H1002V1808ZM231 1808H231.643V1758H231H230.357V1808H231Z",
    fill: "#E3E9E0",
    mask: "url(#path-43-inside-5_11512_2147_f1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_5_f1"
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-6_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1758H431V1808H231V1758Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1808H234V1758H231H228V1808H231Z",
    fill: "#43B017",
    mask: "url(#path-45-inside-6_11512_2147_f1)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_5_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1778.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "#F3FFEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1778.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#4CBC18",
    strokeWidth: 0.6425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_f1",
    d: "M243.901 1783L245.208 1784.44C245.215 1784.45 245.224 1784.45 245.234 1784.46C245.243 1784.46 245.253 1784.46 245.264 1784.46C245.274 1784.46 245.285 1784.46 245.294 1784.46C245.304 1784.45 245.312 1784.45 245.319 1784.44L247.649 1781.88",
    stroke: "#4CBC18",
    strokeWidth: 0.6425,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "8642 Sycamore Ter, New York, NY 10001\\xE2\\x80\\xA83 bd \\xE2\\x80\\xA2 2 ba \\xE2\\x80\\xA2 1,550 sqft \\xE2\\x80\\xA2 1961 yb_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 403.759,
    y: 1780.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1790.3
  }, "3 bd \u2022 2 ba \u2022 1,550 sqft \u2022 1961 yb"))), /*#__PURE__*/React.createElement("text", {
    fill: "#4CBC18",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1780.3
  }, "8642 Sycamore Ter, New York, NY 10001"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_5_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_6_f1"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71,
    y: 1770.5,
    width: 69,
    height: 25,
    rx: 4,
    fill: "#7F8F79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Projects\\xE2\\x80\\xA8Under Construction_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1780.3
  }, "Projects\u2028"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1790.3
  }, "Under Construction")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_5_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 445_2_f1"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1776.5,
    width: 62,
    height: 13,
    rx: 3.5,
    fill: "#EEF2EB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1776.5,
    width: 62,
    height: 13,
    rx: 3.5,
    stroke: "#C8D2C3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Long-Term Rental_f1",
    fill: "#3E4A3C",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.14,
    y: 1785.45
  }, "Long-Term Rental"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_5_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "4/14/25_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 639.4,
    y: 1785.34
  }, "4/14/25"))))), /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-default_3_f1"
  }, _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-7_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1808H1002V1858H231V1808Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1808H1002V1858H231V1808Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 1858V1858.64H1002.64V1858H1002ZM231 1858H230.357V1858.64H231V1858ZM1002 1808H1001.36V1858H1002H1002.64V1808H1002ZM1002 1858V1857.36H231V1858V1858.64H1002V1858ZM231 1858H231.643V1808H231H230.357V1858H231Z",
    fill: "#E3E9E0",
    mask: "url(#path-55-inside-7_11512_2147_f1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 176_6_f1"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "codex:check_6_f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1828.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.601,
    y: 1828.82,
    width: 8.3525,
    height: 8.3525,
    rx: 0.96375,
    stroke: "#DAE4D5",
    strokeWidth: 0.6425
  }))), /*#__PURE__*/React.createElement("g", {
    id: "9876 Willow Way, Seattle, WA 98101\\xE2\\x80\\xA83 bd \\xE2\\x80\\xA2 2 ba \\xE2\\x80\\xA2 1,400 sqft \\xE2\\x80\\xA2 1986 yb_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 387.673,
    y: 1830.3
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1840.3
  }, "3 bd \u2022 2 ba \u2022 1,400 sqft \u2022 1986 yb"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 257.985,
    y: 1830.3
  }, "9876 Willow Way, Seattle, WA 98101"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 180_6_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_7_f1"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71,
    y: 1820.5,
    width: 56,
    height: 25,
    rx: 4,
    fill: "#7F8F79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Acquisitions\\xE2\\x80\\xA8Under Contract_f1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1830.3
  }, "Acquisitions\u2028"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 441.71,
    y: 1840.3
  }, "Under Contract")))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 182_6_f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 444_8_f1"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1826.5,
    width: 43,
    height: 13,
    rx: 3.5,
    fill: "#EEF2EB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 541.64,
    y: 1826.5,
    width: 43,
    height: 13,
    rx: 3.5,
    stroke: "#C8D2C3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Build to Sell_f1",
    fill: "#3E4A3C",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 544.14,
    y: 1835.45
  }, "Build to Sell"))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 184_6_f1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "3/04/26_f1",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.71,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 638.4,
    y: 1835.34
  }, "3/04/26"))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "sheet-row-default_4_f1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-8_11512_2147_f1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 1858H1002V1906H231V1858Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231 1858H1002V1906H231V1858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002 1906V1906.64H1002.64V1906H1002ZM231 1906H230.357V1906.64H231V1906ZM1002 1858H1001.36V1906H1002H1002.64V1858H1002ZM1002 1906V1905.36H231V1906V1906.64H1002V1906ZM231 1906H231.643V1858H231H230.357V1906H231Z",
    fill: "#DAE4D5",
    mask: "url(#path-64-inside-8_11512_2147_f1)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207 -1551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27_f1",
    filter: "url(#filter2_d_11512_2147_f1)",
    "data-figma-bg-blur-radius": 4
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 1527,
    width: 142,
    height: 138,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 457.25,
    y: 1527.25,
    width: 141.5,
    height: 137.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27_2_f1",
    filter: "url(#filter3_d_11512_2147_f1)"
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 469,
    y: 1539,
    width: 118,
    height: 114,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "btn_f1",
    filter: "url(#filter4_d_11512_2147_f1)"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 489,
    y: 1606,
    width: 77.1417,
    height: 27.6793,
    rx: 13.8397,
    fill: "#43B017",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Add Property_f1",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8.99578,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 500.07,
    y: 1622.79
  }, "Add Property")))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 170_f1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 794_f1",
    cx: 527.776,
    cy: 1577.78,
    r: 19.7764,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_f1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.293 1590.99V1585.02H531.275V1596.33C530.141 1596.54 528.972 1596.65 527.777 1596.65C522.495 1596.65 517.719 1594.48 514.293 1590.99ZM532.148 1596.14V1585.02C532.148 1584.52 531.757 1584.11 531.275 1584.11H528.276V1575.56L540.362 1578.52V1591.85C539.397 1592.71 538.343 1593.47 537.216 1594.13V1588.56H534.069V1595.58C533.443 1595.8 532.802 1595.99 532.148 1596.14ZM515.452 1577.05L517.293 1575.95V1584.11H527.403V1569.9L529.364 1568.73C529.464 1568.67 529.537 1568.57 529.567 1568.46C529.597 1568.34 529.581 1568.22 529.523 1568.11C529.465 1568.01 529.37 1567.93 529.258 1567.9C529.146 1567.87 529.027 1567.89 528.927 1567.95L515.015 1576.27C514.807 1576.39 514.735 1576.67 514.856 1576.88C514.976 1577.1 515.243 1577.17 515.452 1577.05ZM519.218 1576.3H521.911V1577.94H519.218V1576.3ZM519.218 1580.49V1578.84H521.911V1580.49H519.218ZM525.478 1580.49H522.785V1578.84H525.478V1580.49ZM525.478 1576.3V1577.94H522.785V1576.3H525.478ZM537.216 1581.37V1585.42H534.069V1581.37H537.216ZM524.032 1587.95H528.286V1592.16H524.032V1587.95ZM517.281 1587.95H521.536V1592.16H517.281V1587.95Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 6_f1",
    d: "M511.146 1558L511.996 1560.3L514.292 1561.15L511.996 1562L511.146 1564.29L510.296 1562L508 1561.15L510.296 1560.3L511.146 1558Z",
    fill: "#43B017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 7_f1",
    d: "M521.032 1564.29L521.639 1565.93L523.28 1566.54L521.639 1567.15L521.032 1568.79L520.425 1567.15L518.785 1566.54L520.425 1565.93L521.032 1564.29Z",
    fill: "#43B017"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8_f1",
    cx: 539.461,
    cy: 1566.09,
    r: 7.64087,
    fill: "#43B017",
    stroke: "white",
    strokeWidth: 0.898926
  }), /*#__PURE__*/React.createElement("path", {
    id: "+_f1",
    d: "M538.915 1569.69V1562.5H540.042V1569.69H538.915ZM535.867 1566.66V1565.54H543.059V1566.66H535.867Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_3_f1",
    filter: "url(#filter5_d_11512_2147_f1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571 1635.76C570.995 1636.01 570.905 1636.26 570.743 1636.46C570.58 1636.66 570.354 1636.81 570.096 1636.89L564.328 1638.52C564.027 1638.6 563.754 1638.76 563.532 1638.97C563.31 1639.17 563.146 1639.43 563.055 1639.72L561.323 1645.15C561.245 1645.39 561.087 1645.6 560.872 1645.76C560.657 1645.91 560.396 1646 560.126 1646C559.856 1646.01 559.59 1645.93 559.367 1645.79C559.144 1645.65 558.975 1645.44 558.885 1645.2L554.065 1631.58C553.991 1631.37 553.98 1631.14 554.034 1630.92C554.088 1630.71 554.206 1630.51 554.373 1630.35C554.54 1630.19 554.751 1630.08 554.981 1630.03C555.211 1629.98 555.452 1629.99 555.676 1630.06L570.14 1634.6C570.395 1634.68 570.616 1634.84 570.77 1635.05C570.925 1635.26 571.005 1635.5 571 1635.76Z",
    fill: "#17270D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.089 1630.52C555.234 1630.49 555.386 1630.49 555.526 1630.54L569.99 1635.08C570.148 1635.13 570.28 1635.23 570.369 1635.35C570.459 1635.47 570.503 1635.61 570.5 1635.75V1635.75C570.497 1635.89 570.447 1636.03 570.353 1636.15C570.281 1636.24 570.186 1636.31 570.075 1636.36L569.959 1636.4L564.191 1638.04H564.19C563.815 1638.14 563.47 1638.34 563.188 1638.6C562.907 1638.87 562.697 1639.2 562.579 1639.56L562.578 1639.56L560.847 1645C560.803 1645.13 560.712 1645.26 560.582 1645.35C560.451 1645.44 560.289 1645.5 560.118 1645.5L560.11 1645.5C559.94 1645.51 559.774 1645.46 559.638 1645.37C559.502 1645.28 559.404 1645.16 559.353 1645.03L554.537 1631.41C554.495 1631.29 554.489 1631.17 554.52 1631.04C554.55 1630.92 554.616 1630.81 554.716 1630.71C554.816 1630.62 554.944 1630.55 555.089 1630.52Z",
    stroke: "#F4FAEF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature-1.7d04e266b8d6b4191f90cfee22d2d9c3.svg";
export { ForwardRef as ReactComponent };